const PATIENT_TYPE = 'patient';
const DOCTOR_TYPE = 'doctor';

export default { PATIENT_TYPE, DOCTOR_TYPE };
